
import { useState, useEffect } from 'react';

const useWindowDimensions = () => {

  const hasWindow = typeof window !== 'undefined';

  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : null;
    return {
      isMobile: width && width <= 767 ? true : false,
      isTablet: width && width > 767 && width <= 1024 ? true : false,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  const handleResize = () => {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    if (hasWindow) {
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasWindow]);

  return windowDimensions;
}
export default useWindowDimensions;
